import { palette } from '@openx/components-core/lib/theme/paletteV2';
import {
  ArmchairIcon,
  BackpackIcon,
  BriefcaseIcon,
  DesktopIcon,
  DotsThreeIcon,
  GearIcon,
  GraduationCapIcon,
  HandCoinsIcon,
  HandshakeIcon,
  HardHatIcon,
  type Icon,
  KeyIcon,
  TractorIcon,
  UserIcon,
  UsersIcon,
  UsersThreeIcon,
} from '@phosphor-icons/react';

export type BucketConfig = {
  key: string;
  label: string;
  color: string;
};

export const UNKNOWN_BUCKET_KEY = 'unknown';

const UNKNOWN_BUCKET: BucketConfig = {
  key: UNKNOWN_BUCKET_KEY,
  label: 'Unknown',
  color: palette.background.grayLight,
};

/** Household size buckets in display order; API buckets outside this list are folded into "Unknown" */
export const HOUSEHOLD_SIZE_BUCKETS: BucketConfig[] = [
  { key: '1-2', label: '1-2 people', color: palette.charts.purple },
  { key: '3-5', label: '3-5 people', color: palette.charts.indigo },
  { key: '6+', label: '6+ people', color: palette.charts.lightBlue },
  UNKNOWN_BUCKET,
];

/** CTV-per-household buckets — same API keys and colors as household size, labelled as device counts */
export const HOUSEHOLD_CTV_BUCKETS: BucketConfig[] = [
  { key: '1-2', label: '1-2 CTV', color: palette.charts.purple },
  { key: '3-5', label: '3-5 CTV', color: palette.charts.indigo },
  { key: '6+', label: '6+ CTV', color: palette.charts.lightBlue },
  UNKNOWN_BUCKET,
];

export const AGE_BUCKETS = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'];

export const GENDER = {
  male: 'male',
  female: 'female',
} as const;

export type MetricListBucketConfig = {
  key: string;
  label: string;
  icon: Icon;
};

/** Household profile in display order */
export const HOUSEHOLD_PROFILE_BUCKETS: MetricListBucketConfig[] = [
  { key: 'homeowners', label: 'Homeowners', icon: KeyIcon },
  { key: 'without_children', label: 'Without children', icon: UsersIcon },
  { key: 'adults', label: 'Adults', icon: UserIcon },
  { key: 'college_educated', label: 'College Educated', icon: GraduationCapIcon },
  { key: 'rentals', label: 'Rentals', icon: HandCoinsIcon },
  { key: 'with_children', label: 'With children', icon: UsersThreeIcon },
  { key: 'below_bachelor', label: 'Below Bachelor', icon: BackpackIcon },
  { key: 'young_adults', label: 'Young Adults', icon: UserIcon },
];

/** Occupation groups in display order */
export const OCCUPATION_GROUP_BUCKETS: MetricListBucketConfig[] = [
  { key: 'blue_collar', label: 'Blue Collar', icon: HardHatIcon },
  { key: 'farmer', label: 'Farmer', icon: TractorIcon },
  { key: 'office_administration', label: 'Office Administration', icon: DesktopIcon },
  { key: 'management', label: 'Management', icon: UsersThreeIcon },
  { key: 'sales', label: 'Sales', icon: HandshakeIcon },
  { key: 'technical', label: 'Technical', icon: GearIcon },
  { key: 'professional', label: 'Professional', icon: BriefcaseIcon },
  { key: 'retired', label: 'Retired', icon: ArmchairIcon },
  { key: 'others', label: 'Others', icon: DotsThreeIcon },
];
